export default __webpack_public_path__ + "static/media/img11.783775a3.png";